module.exports = __webpack_public_path__ + "img/about-logo-2.2dff31eb.png";